import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Grid, IconButton, InputAdornment, Typography } from "@mui/material";

import { Paper, TextField } from "../../../components";

export default function FormDisplay({ formikProps }) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Paper style={{ width: "600px" }}>
      <Grid item xs={12}>
        <Typography variant="h2" align="center">
          Verismart
        </Typography>

        <Typography variant="body1" align="center">
          Sign in to your account to continue!
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          name="email"
          label="Email Address"
          formikProps={formikProps}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          type={showPassword ? "text" : "password"}
          name="password"
          label="Password"
          formikProps={formikProps}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  style={{ padding: 0 }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <VisibilityIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs />

      {/* <Grid item alignSelf="center">
        <Link href="/forgot-password">Forgot Password?</Link>
      </Grid> */}

      <Grid item xs={12}>
        <LoadingButton
          type="submit"
          variant="contained"
          fullWidth
          onClick={formikProps.handleSubmit}
          disabled={!formikProps.dirty || !formikProps.isValid}
          loading={formikProps.isSubmitting}
        >
          Sign In
        </LoadingButton>
      </Grid>
    </Paper>
  );
}
